import React from 'react';
import { Select } from 'antd';
import firebase from 'firebase/compat/app';
import { getUniqueItemsBySubGroupId } from 'components/ReportModal/getSubGroups';
import { useAppSelector } from 'hooks';
// import { DBGroupShape } from '../../modules/groups/types';

const { Option } = Select;

const db = firebase.firestore();

export default function SubGroupSelect({
  orgId,
  groupId,
}: // groups,
{
  orgId: string;
  groupId?: string;
  // groups: DBGroupShape[];
}) {
  const orgs = useAppSelector((state) => state.orgs.orgs);
  const currentSubGroup = orgs.find((org) => org.id === orgId)?.subGroup;
  const subGroups = getUniqueItemsBySubGroupId(orgs).map((org) => ({
    id: org?.subGroup?.id,
    title: org?.subGroup.title,
  }));
  const handleChange = async (value: string) => {
    try {
      console.log(`selected ${value} - orgId=${orgId} - groupId=${groupId}`);
      if (!orgId) return alert('Invalid orgId');
      const subGroup = subGroups.find((subGroup) => subGroup.id === value);
      if (!subGroup?.id || !subGroup?.title) return alert('Invalid subGroupId');
      await db
        .collection('orgs')
        .doc(orgId)
        .set(
          {
            subGroup: {
              id: subGroup.id,
              title: subGroup.title,
            },
          },
          { merge: true }
        );
    } catch (error) {
      console.error(error);
    }
  };
  if (!groupId || !orgId || subGroups?.length < 1) return 'Ingen undergrupper fundet';
  return (
    <Select defaultValue={currentSubGroup?.id} style={{ width: '100%' }} onChange={handleChange}>
      {subGroups
        ?.sort((a, b) =>
          a.title?.localeCompare(b.title, 'da', {
            sensitivity: 'base',
            numeric: true,
          })
        )
        .map(({ id, title }) => (
          <Option value={id}>{title}</Option>
        ))}
    </Select>
  );
}
